module.exports = __webpack_public_path__ + "img/3.5.COD.5922b189.png";